export default "__VITE_ASSET__BySzBV24__"